module.exports = __webpack_public_path__ + "img/logo96320.d5069a21.png";